import { render, staticRenderFns } from "./ProfileCommitmentsStat.vue?vue&type=template&id=247b2a90"
import script from "./ProfileCommitmentsStat.vue?vue&type=script&lang=js"
export * from "./ProfileCommitmentsStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports